import React from 'react';
import PropTypes from 'prop-types';
import { Button, Microphone01, PhoneX, Spinner, XClose } from '@opendate-app/setlist';
import { conductorTheme } from '../themeTokens';

const VoiceComposerButton = ({
  status,
  error,
  onStart,
  onStop,
  onDismissError,
  ghost = false
}) => {
  const isConnecting = status === 'connecting';
  const isActive = status === 'listening' || status === 'paused';
  const buttonLabel = isActive ? 'End voice' : 'Start voice';
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '6px',
      flexShrink: 0
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button
          type="button"
          aria-label={buttonLabel}
          title={buttonLabel}
          onClick={isActive ? onStop : onStart}
          disabled={isConnecting}
          style={{
            width: ghost ? '40px' : '44px',
            height: ghost ? '40px' : '44px',
            borderRadius: '8px',
            border: isActive ? '1px solid #991b1b' : ghost ? 'none' : `1px solid ${conductorTheme.borderStrong}`,
            backgroundColor: isActive ? '#b91c1c' : ghost ? 'transparent' : conductorTheme.surface,
            color: isActive ? '#fff' : ghost ? 'var(--od-c-475569, #535862)' : conductorTheme.textBody,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: isConnecting ? 'default' : 'pointer',
            opacity: isConnecting ? 0.72 : 1,
            flexShrink: 0,
            lineHeight: 1
          }}
        >
          {isConnecting ? (
            <Spinner size={18} color="currentColor" />
          ) : isActive ? (
            <PhoneX width={20} height={20} aria-hidden="true" />
          ) : (
            <Microphone01 width={ghost ? 20 : 22} height={ghost ? 20 : 22} aria-hidden="true" />
          )}
        </button>
      </div>
      {error && (
        <div
          role="alert"
          style={{
            maxWidth: '260px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: '#991b1b',
            fontSize: '12px',
            lineHeight: 1.35,
            textAlign: 'right'
          }}
        >
          <span>{error}</span>
          <Button variant="tertiary" size="sm" icon={XClose} aria-label="Dismiss voice error" onClick={onDismissError} />
        </div>
      )}
    </div>
  );
};

VoiceComposerButton.propTypes = {
  status: PropTypes.oneOf(['idle', 'connecting', 'listening', 'paused']).isRequired,
  error: PropTypes.string,
  onStart: PropTypes.func.isRequired,
  onStop: PropTypes.func.isRequired,
  onDismissError: PropTypes.func.isRequired,
  ghost: PropTypes.bool
};

VoiceComposerButton.defaultProps = {
  error: null
};

export default VoiceComposerButton;
